var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStrava = function SvgStrava(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.387 17.944-2.089-4.116h-3.065L15.387 24l5.15-10.172h-3.066zm-6.087-12L12 0l2.7 5.944H24l-6.3 12.39-3.15-6.166h3.9L12 0 5.7 12.168h3.9l-3.15 6.166L0 5.944z"
  })));
};
export default SvgStrava;